/* eslint-disable */
import React, { Component } from "react";
import DataListItem from "./DataListItem/DataListItem";
import "./DataList.css";
import ReactTooltip from "react-tooltip";

class DataList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            weather: this.props.weather,
        };
    }

    render() {
        let { weather } = this.state;
        let renderRowsToDisplay = {};
        if (weather) {
            weather = weather.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.location === value.location
                ))
            )

            console.log(weather)
            renderRowsToDisplay = weather.map((item, index) => {
                return <DataListItem key={index} data={item} />;
            })

        }

        return (
            <>
                <table className="tbCenter">
                <thead className="tHead">
                        <tr className="">
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Luogo</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Temp</strong>
                                </p>
                            </td>

                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Vento</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Vento Da</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Vento AVG</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Vento Raffica</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Umidita</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>Pioggia</strong>
                                </p>
                            </td>
                        </tr>
                    </thead>
                    <thead className="tHeadDescr">
                        <tr className="">
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>-</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>&deg;C</strong>
                                </p>
                            </td>

                            <td className="">
                                <p className=" txtCenter">
                                    <strong>kts</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>-</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>kts</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>kts</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>%</strong>
                                </p>
                            </td>
                            <td className="">
                                <p className=" txtCenter">
                                    <strong>mm</strong>
                                </p>
                            </td>
                        </tr>
                    </thead>

                    <tbody>{renderRowsToDisplay}</tbody>
                </table>
            </>
        );
    }
}

export default DataList;
